import { set } from '@/utils/vuex';

export default {
  onAlert: set('alert'),
};
